const initializeOnLoad = () => {
  $(window).on("turbolinks:load", function onLoad() {
    $("body").addClass("loaded");
  });
  $("body").addClass("loaded");
};

export default initializeOnLoad;
